import type { DirectorEmailTemplate, SendMessagesResponse } from '@league/shared/contract';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost } from '../../lib/api';

/** Both email presentations use the same queue API and its server-side retry/deduplication. */
export function useLeagueEmailSend(leagueId: string, onQueued?: () => void) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ template, note }: { template: DirectorEmailTemplate; note?: string }) =>
      apiPost<SendMessagesResponse>(`/api/leagues/${leagueId}/messages`, {
        templateType: template.kind,
        ...(note?.trim() ? { directorNote: note.trim() } : {}),
        ...(template.seatingVersion ? {seatingVersion:template.seatingVersion} : {}),
        ...(template.sessionId ? { sessionId: template.sessionId } : {}),
      }),
    onSuccess: async () => {
      onQueued?.();
      await client.invalidateQueries({ queryKey: ['messages', leagueId] });
      await client.invalidateQueries({ queryKey: ['director-next-steps'] });
    },
  });
}
